module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av568-2e90aa6b70571e0b11d25c445a0311e4.jpg";